import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding-top":"80px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_result = _resolveComponent("a-result")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_result, {
      status: "404",
      title: "404",
      "sub-title": "抱歉, 你访问的页面不存在."
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("返回首页")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}